// Email patterns
export const emailPattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;

// Specific company names to mask
export const specificCompanyNamesPattern = /\b(?:Inspectorio|Walmart|Target|Inditex|Carter|Kohl|Mango|Standard Fiber|Vera Bradley|Yunus|Delta Galil|Barco Uniforms|Centric Brands|Farylrobin|Inmocean|Lacrosse|Mohawk)\b/gi;

// Phone number patterns
export const phonePattern = /\b(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}\b/g;
export const ukPhonePattern = /\b\+44\s\d{4}\s\d{6}\b/g;

// Financial information patterns
export const ssnPattern = /\b\d{3}[-]?\d{2}[-]?\d{4}\b/g;
export const creditCardPattern = /\b(?:\d{4}[-\s]?){3}\d{4}\b/g;
export const creditCardAltPattern = /\b(?:\d{4}[\s-]?){4}|\b\d{16}\b/g;
export const bankAccountPattern = /\b(?:bank account|account number)(?:\s*is|\s*:)?\s*["']?(\d{8,12})["']?/gi;
export const bankAccountNumberPattern = /\b\d{8,12}\b/g;
export const dollarAmountPattern = /\$\d{1,3}(?:,\d{3})*(?:\.\d{2})?/g;

// Personal information patterns
export const addressPattern = /\b\d+\s+[A-Za-z0-9\s,\.]+(?:Avenue|Lane|Road|Boulevard|Drive|Street|Ave|Dr|Rd|Blvd|Ln|St|Terrace)\.?(?:\s*,\s*[A-Za-z\s]+(?:,\s*[A-Z]{2})?\s*\d{5}(?:-\d{4})?)?/gi;
export const namePattern = /\b(?:Mr\.|Mrs\.|Ms\.|Dr\.|Prof\.)\s+[A-Z][a-z]+\s+[A-Z][a-z]+\b/g;
export const companyNamePattern = /\b[A-Z][a-z]+(?:[A-Z][a-z]+)*\b(?=\s+(?:Inc|LLC|Ltd|Limited|Corporation|Corp|Company|Co|GmbH|SA|AG|NV|BV|from|asked|at|of))\b/g;
export const passwordPattern = /\b[Pp]assword(?:\s*is|\s*:)?\s*["']?([^"'\s,\.]{6,})["']?/g;
export const dobPattern = /\b(?:born on|birth date|date of birth|DOB|D\.O\.B\.|birthday)(?:\s*is|\s*:)?\s*["']?(\d{4}[-/]\d{1,2}[-/]\d{1,2}|\d{1,2}[-/]\d{1,2}[-/]\d{4}|\d{1,2}(?:st|nd|rd|th)?\s+(?:of\s+)?(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:tember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)\s+\d{4})["']?/gi;
export const datePattern = /\b\d{4}[-/]\d{1,2}[-/]\d{1,2}\b|\b\d{1,2}[-/]\d{1,2}[-/]\d{4}\b/g;

// API and technical information patterns
export const apiKeyPattern = /\b(?:api key|API key|key)(?:\s*is|\s*:)?\s*["'=]?([a-zA-Z0-9_]{10,})["'=]?/gi;
export const stripeApiKeyPattern = /\b(?:sk|pk|rk)_(?:test|live)_[a-zA-Z0-9]{10,}/g;
export const transactionIdPattern = /\b(?:transaction|tx|transaction id|tx id|transaction ID|TX ID)(?:\s*is|\s*:|\s*#)?\s*(\d{4,8})\b/gi;
export const invoicePattern = /\b(?:INV|inv)[-\s]?\d{4,8}\b/g;
export const ticketNumberPattern = /\b(?:ticket|Ticket)(?:\s*#|\s*number|\s*ID|\s*:)?\s*\d{4,8}\b/g;
export const ipAddressPattern = /\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/g;
export const ipAddressWithPortPattern = /\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?):[0-9]{1,5}\b/g;

// Environment variable patterns
// Value (.*?) is non-greedy, followed by a lookahead for common delimiters (comma, space, period) or end-of-string.
export const envVarPattern = /\b([A-Z0-9_]*(?:SECRET|PASSWORD|TOKEN|KEY|AUTH|CREDENTIAL|PRIVATE)[A-Z0-9_]*)=(.*?)(?=[,\s.]|$)/gi;

// Combine all patterns into a single object for backward compatibility
export const patterns = {
  email: emailPattern,
  phone: phonePattern,
  ukPhone: ukPhonePattern,
  ssn: ssnPattern,
  creditCard: creditCardPattern,
  address: addressPattern,
  name: namePattern,
  companyName: companyNamePattern,
  specificCompanyNames: specificCompanyNamesPattern,
  password: passwordPattern,
  dob: dobPattern,
  date: datePattern,
  creditCardAlt: creditCardAltPattern,
  bankAccount: bankAccountPattern,
  bankAccountNumber: bankAccountNumberPattern,
  apiKey: apiKeyPattern,
  stripeApiKey: stripeApiKeyPattern,
  transactionId: transactionIdPattern,
  dollarAmount: dollarAmountPattern,
  invoice: invoicePattern,
  ticketNumber: ticketNumberPattern,
  ipAddress: ipAddressPattern,
  ipAddressWithPort: ipAddressWithPortPattern,
  envVar: envVarPattern,
};
